// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_s__","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_V-O StatelessWorkCardsUpsellModal-styles-cls1_s__"};